// extracted by mini-css-extract-plugin
export default {"countdown":"Faa-z","srOnly":"Gaa-z"};